import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatError,  MatHint} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import {Subject, takeUntil} from 'rxjs';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {InfoMessageService} from '../../services/infomessage/infomessage.service';
import {ErrorMatcher} from '../../classes/error-matcher/error-matcher';
import {MatDialog} from '@angular/material/dialog';
import {PasswordForgotDialogComponent} from '../password-forgot-dialog/password-forgot-dialog.component';
import {DeviceDetectionService} from '../../services/device-detection/device-detection.service';
import {NgClass} from '@angular/common';
import {
    ResendRegisterLinkModalComponent
} from '../modals/resend-register-link-modal/resend-register-link-modal.component';

import {IconComponent} from '../shared/icon/icon.component';

@Component({
  selector: 'app-login',
    imports: [
        MatInput,
        ReactiveFormsModule,
        RouterLink,
        NgClass,
        IconComponent
    ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.sass'
})
export class LoginComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    emailFormControl = new FormControl('', [Validators.required, Validators.email]);
    passwordFormControl = new FormControl('', Validators.required);

    matcher = new ErrorMatcher();

    isBookingAfterLogin: boolean = false;

    isMobile: boolean = false;
    hidePassword: boolean = true;
    constructor(
        private authenticationService: AuthenticationService,
        private infoMessageService: InfoMessageService,
        private router: Router,
        private dialog: MatDialog,
        private deviceDetectionService: DeviceDetectionService
    ) {
        this.isMobile = deviceDetectionService.getIsMobile();
        const navigation = this.router.getCurrentNavigation();
        const booking = navigation?.extras?.state?.['booking'];
        if (booking) {
            this.isBookingAfterLogin = booking
        }
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onLogin(): void {
        if (this.emailFormControl.invalid || this.passwordFormControl.invalid) {
            this.emailFormControl.markAsTouched();
            this.passwordFormControl.markAsTouched();
            return;
        }
        this.login(this.isBookingAfterLogin);
    }

    forgotPassword(): void {
        const dialogRef = this.dialog.open(PasswordForgotDialogComponent, {
            closeOnNavigation: true,
            disableClose: true
        });
        dialogRef.afterClosed().subscribe(email => {
            if (email) {
                this.sendPasswordForgottenMail(email);
            }
        })
    }

    openResendLinkModal(): void {
        const dialogRef = this.dialog.open(ResendRegisterLinkModalComponent, {
            disableClose: true,
            closeOnNavigation: false
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.infoMessageService.createMessage('Falls Sie Ihre E-Mail-Adresse noch nicht bestätigt haben, erhalten Sie jetzt eine neue E-Mail mit Bestätigungslink.')
            }
        })
    }

    private login(isBookingAfterLogin: boolean = false): void {
        this.authenticationService.login({
            username: this.emailFormControl.value,
            password: this.passwordFormControl.value
        }, isBookingAfterLogin)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                },
                error: (error) => {
                    this.infoMessageService.createMessage('Login fehlgeschlagen. Bitte überprüfen Sie Ihr Passwort oder gehen Sie auf Passwort vergessen. Sollten Sie Ihre E-Mail-Adresse noch nicht bestätigt haben, erhalten Sie in Kürze eine E-Mail mit einem neuen Bestätigungslink', 'error');
                }
            });
    }

    private sendPasswordForgottenMail(email: string): void {
        this.authenticationService.sendPasswordForgottenMail(email)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    this.infoMessageService.createMessage('Sie bekommen in Kurze eine E-Mail zum Zurücksetzen des Passworts', 'success');
                },
                error: (error) => {
                    this.infoMessageService.createMessage('Passwort zurücksetzen fehlgeschlagen', 'error');
            }})
    }
}
